import { FunctionComponent, memo, useMemo } from 'react';

import classNames from 'classnames';
import classes from './CircularLoader.module.scss';

interface CircularLoaderProps {
  progress?: number;
  text?: string;
  sizeRem?: number;
  borderRem?: number;
  className?: string;
}

export const CircularLoader: FunctionComponent<CircularLoaderProps> = memo(
  ({ progress, text, sizeRem = 1.75, borderRem = 0.25, className }) => {
    const progressLabel = useMemo(() => {
      if (progress && progress < 100) {
        return <span className={classes['loader__progress-label']}>{progress}%</span>;
      }

      if (text) {
        return <span className={classes['loader__progress-label']}>{text}</span>;
      }

      return null;
    }, [progress, text]);

    return (
      <div className={classNames(classes['loader'], className)}>
        {progressLabel}
        <div
          className={classes['loader__body']}
          style={{
            width: `${sizeRem}rem`,
            height: `${sizeRem}rem`,
            borderWidth: `${borderRem}rem`,
          }}
        ></div>
      </div>
    );
  }
);
